import { Code, ConnectError } from '@connectrpc/connect'
import type { TFunction } from 'i18next'

const DEFAULT_KEYS: Partial<Record<Code, string>> = {
  [Code.Aborted]: 'common:connectError.aborted',
  [Code.InvalidArgument]: 'common:connectError.invalidArgument',
  [Code.NotFound]: 'common:connectError.notFound',
  [Code.AlreadyExists]: 'common:connectError.alreadyExists',
}

const UNKNOWN_KEY = 'common:connectError.unknown'

export function mapConnectErrorToMessage(
  err: ConnectError,
  t: TFunction,
  customKeys?: Partial<Record<Code, string>>,
  unknownKey?: string,
): string {
  const key = customKeys?.[err.code] ?? DEFAULT_KEYS[err.code]
  if (key !== undefined) {
    return t(key)
  }
  return unknownKey !== undefined ? t(unknownKey) : t(UNKNOWN_KEY)
}

export function mapErrorToMessage(
  err: unknown,
  t: TFunction,
  customKeys?: Partial<Record<Code, string>>,
  unknownKey?: string,
): string {
  if (err instanceof ConnectError) {
    return mapConnectErrorToMessage(err, t, customKeys, unknownKey)
  }
  return unknownKey !== undefined ? t(unknownKey) : t(UNKNOWN_KEY)
}
